import { useQuery } from '@apollo/client'
import { SearchableCombobox, TSearchable } from '../base/combobox'
import { TaxRateSelectorQuery, SelectedTaxRateSelectorQuery } from './__generated__/selector_query'
import { Query, SelectedQuery } from './selector_query'
import { useCombobox } from '@/helpers/useCombobox'
import { dedupe } from '@/helpers/dedupe'

type TaxRate = SelectedTaxRateSelectorQuery['taxRates']['nodes'][0]

interface Props {
  value: string
  onChange: (value: TSearchable | null) => void
  invalid: boolean
}

export const Selector = ({ value, onChange, invalid }: Props) => {
  const { data: selectedData } = useQuery<SelectedTaxRateSelectorQuery>(
    SelectedQuery,
    { variables: { id: value || 'blank' } }
  )
  const { data, loading, refetch, fetchMore } = useQuery<TaxRateSelectorQuery>(Query, { variables: { first: 10 } })

  const { pageInfo, items } = useCombobox<TaxRate>({
    pageInfo: data?.taxRates.pageInfo,
    querySelected: selectedData?.taxRates.nodes[0],
    queryCollection: data?.taxRates.nodes,
    buildSearchable: item => ({
      id: item.id,
      name: item.name,
    })
  })

  return (
    <SearchableCombobox
      data={items}
      invalid={invalid}
      loading={loading}
      moreToFetch={pageInfo.current?.hasNextPage}
      refetch={refetch}
      searchField="nameCont"
      value={items.find(d => d.id == value) || { id: '', name: '' }}
      fetchMore={() => fetchMore({
        variables: { after: pageInfo.current?.endCursor },
        updateQuery(previousData, { fetchMoreResult }) {
          if (Object.keys(previousData).length === 0) return fetchMoreResult
          fetchMoreResult.taxRates.nodes = dedupe([
            ...previousData.taxRates.nodes,
            ...fetchMoreResult.taxRates.nodes
          ])

          return { ...fetchMoreResult }
        }
      })}
      onChange={onChange}
    />
  )
}
